import { render, staticRenderFns } from "./PageVerifyChangeEmail.vue?vue&type=template&id=2a7f6c2c&scoped=true&"
import script from "./PageVerifyChangeEmail.vue?vue&type=script&lang=js&"
export * from "./PageVerifyChangeEmail.vue?vue&type=script&lang=js&"
import style0 from "./PageVerifyChangeEmail.vue?vue&type=style&index=0&id=2a7f6c2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f6c2c",
  null
  
)

export default component.exports